import { Camera, MessageCircle } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/site/Reveal";
import { EnquiryForm } from "@/components/site/EnquiryForm";
import { WhatsAppButton } from "@/components/site/Buttons";
import { usePageMeta } from "@/lib/usePageMeta";
import { PROCESS } from "@/content/site";

export default function RequestRepair() {
  usePageMeta(
    "Request a Power Tool Repair in Newcastle | NE Tool Repair",
    "Send a repair enquiry for your Milwaukee M12, M18 or other power tool. NE Tool Repair serves Newcastle upon Tyne and the North East.",
    "/request-a-repair"
  );
  return (
    <section className="relative border-b border-[var(--line)]" data-testid="request-repair-page">
      <div className="absolute inset-x-0 top-0 h-[480px] grid-lines [mask-image:linear-gradient(to_bottom,black,transparent)]" aria-hidden />
      <div className="relative mx-auto max-w-[1400px] px-5 md:px-10 py-16 md:py-24 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <Eyebrow>Repair enquiry</Eyebrow>
              <h1 className="mt-6 font-display font-black uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">Request a<br /><span className="text-[var(--red)]">repair</span></h1>
              <p className="mt-6 text-base text-[var(--grey)] leading-relaxed max-w-md">Tell us about your tool and what's going wrong. There's no booking fee and no account to create.</p>
            </Reveal>
            <ol className="mt-10 border-t border-[var(--line)]">
              {PROCESS.map((p) => (
                <li key={p.n} className="flex gap-5 py-4 border-b border-[var(--line)]">
                  <span className="font-mono text-xs text-[var(--red)] pt-1">{p.n}</span>
                  <span className="font-display font-extrabold uppercase text-xl">{p.title}</span>
                </li>
              ))}
            </ol>
            <div className="mt-10 flex gap-4 text-sm text-[var(--grey)] leading-relaxed">
              <Camera className="h-5 w-5 text-[var(--red)] shrink-0 mt-0.5" aria-hidden />
              <p>Photos of the fault help a lot. After sending this form, you can send them to us on WhatsApp.</p>
            </div>
            <div className="mt-6 flex gap-4 text-sm text-[var(--grey)] leading-relaxed">
              <MessageCircle className="h-5 w-5 text-[var(--wa)] shrink-0 mt-0.5" aria-hidden />
              <p>Prefer to chat? Message us on WhatsApp instead.</p>
            </div>
            <WhatsAppButton testId="request-whatsapp-btn" className="mt-6" />
          </div>
        </div>
        <Reveal className="lg:col-span-7 relative" delay={0.1}>
          <EnquiryForm />
        </Reveal>
      </div>
    </section>
  );
}
